export const hasDecimal = (n: number) => !!(n % 1);
